function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.996,
    height: 16.109,
    viewBox: "0 0 5.291 4.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#00caff",
      fillRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.055 7.406v15.59a1 1 0 0 1-2 0V7.406l-5.3 5.3a1 1 0 1 1-1.4-1.42l7-7a1 1 0 0 1 1.4 0l7 7a1 1 0 1 1-1.4 1.42l-5.3-5.31Z",
    style: {
      fill: "#ee3b77",
      fillOpacity: 1
    },
    transform: "matrix(0 .26458 -.26458 0 6.349 -1.588)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowNegative);
export default __webpack_public_path__ + "static/media/right-arrow-negative.d99e09c1ce86c6f63bcd2cc791d18145.svg";
export { ForwardRef as ReactComponent };